import { CvtStatusData, GetCVTsResponse } from '@packages/models/api/cvt';
import { Dispatch } from 'react';

export enum CvtActionsList {
    CLEAR_CVT_DATA = 'CLEAR_CVT_DATA',
    CLEAR_ERRORS = 'CLEAR_ERRORS',
    HAS_ERRORS = 'HAS_ERRORS',
    HAS_FETCHED = 'HAS_FETCHED',
    HAS_LOADED = 'HAS_LOADED',
    IS_LOADING = 'IS_LOADING',
    SET_CVT_LIST = 'SET_CVT_LIST',
    SET_CVT_STATUS = 'SET_CVT_STATUS',
    REMOVE_CVT = 'REMOVE_CVT',
    SET_LOADING = 'SET_LOADING',
}

export type CvtAction =
    | { type: CvtActionsList.CLEAR_CVT_DATA }
    | { type: CvtActionsList.CLEAR_ERRORS }
    | { type: CvtActionsList.HAS_ERRORS; payload: { errors: string[] } }
    | { type: CvtActionsList.HAS_FETCHED }
    | { type: CvtActionsList.HAS_LOADED }
    | { type: CvtActionsList.IS_LOADING }
    | { type: CvtActionsList.SET_CVT_LIST; payload: { cvtList: GetCVTsResponse } }
    | { type: CvtActionsList.SET_CVT_STATUS; payload: { cvtStatus: CvtStatusData } }
    | { type: CvtActionsList.REMOVE_CVT; payload: { diagnosticId: string } };

export type CvtActionDispatcher = Dispatch<CvtAction>;

export interface CvtState {
    cvtList: GetCVTsResponse | null;
    cvtStatus: CvtStatusData | null;
    errors: string[];
    loading: boolean;
    hasFetched: boolean;
}

export const initialState: CvtState = {
    cvtList: null,
    cvtStatus: null,
    errors: [],
    loading: false,
    hasFetched: false,
};

export const cvtReducer = (state: CvtState, action: CvtAction): CvtState => {
    switch (action.type) {
        case CvtActionsList.SET_CVT_LIST:
            return {
                ...state,
                cvtList: action.payload.cvtList,
                loading: false,
            };
        case CvtActionsList.SET_CVT_STATUS:
            return {
                ...state,
                cvtStatus: action.payload.cvtStatus,
                loading: false,
            };
        case CvtActionsList.CLEAR_CVT_DATA:
            return {
                ...state,
                cvtList: null,
                cvtStatus: null,
                errors: [],
                loading: false,
            };
        case CvtActionsList.CLEAR_ERRORS:
            return {
                ...state,
                errors: [],
            };
        case CvtActionsList.HAS_ERRORS:
            return {
                ...state,
                errors: action.payload.errors,
            };
        case CvtActionsList.HAS_FETCHED:
            return {
                ...state,
                hasFetched: true,
            };
        case CvtActionsList.HAS_LOADED:
            return {
                ...state,
                loading: false,
            };
        case CvtActionsList.IS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case CvtActionsList.REMOVE_CVT: {
            return state.cvtList
                ? {
                      ...state,
                      cvtList: {
                          ...state.cvtList,
                          results: state.cvtList.results.filter(
                              (cvt) => cvt.diagnosticId !== action.payload.diagnosticId
                          ),
                          totalCount: state.cvtList.totalCount - 1,
                      } as GetCVTsResponse,
                  }
                : state;
        }

        default:
            throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
};
